import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpCommonService } from './http-common.service';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private accessToken: string = '';
    private expiry: number = 0;

    constructor(private httpCommonService: HttpCommonService) { }

    /** Get new access token */
    private fetchToken(): Observable<string> {
        const body = {
            username: environment.username,
            password: environment.password
        };

        return this.httpCommonService.postRecord('authenticate', body).pipe(
            map(res => {
                this.accessToken = res.arrowxl_authentication.token ?? '';
                this.expiry = Date.now() + (24 * 60 * 60 * 1000);
                sessionStorage.setItem('access_token', this.accessToken);
                sessionStorage.setItem('token_expiry', this.expiry.toString());
                return this.accessToken;
            })
        );
    }

    /** Return valid token (reuse if not expired) */
    getToken(): Observable<string> {
        if (!this.accessToken) {
            this.accessToken = sessionStorage.getItem('access_token') ?? '';
            this.expiry = Number(sessionStorage.getItem('token_expiry')) || 0;
        }

        if (this.accessToken && Date.now() < this.expiry) {
            return of(this.accessToken);
        }

        return this.fetchToken();
    }

}
